import React from "react";
import { IIcons } from "./icons";

const Confirm = ({ fillColor }: IIcons.IconProps) => (
  <svg
    width="214"
    height="206"
    viewBox="0 0 214 206"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={fillColor}
  >
    <path
      d="M107 0.757812C105.075 0.757812 103.15 1.4866 101.661 2.93136L87.0135 17.1357L66.856 14.2758C62.7511 13.69 58.9315 16.4867 58.2117 20.5867L54.6779 40.7206L36.7053 50.2919C33.0381 52.2442 31.5805 56.7535 33.3995 60.4923L42.3478 78.8531L33.3995 97.2138C31.5805 100.953 33.0381 105.462 36.7053 107.414L54.6969 116.985L58.2117 137.119C58.9315 141.219 62.7511 144.016 66.856 143.43L87.0325 140.57L101.661 154.775C104.638 157.664 109.381 157.664 112.358 154.775L127.006 140.57L147.163 143.43C151.268 144.016 155.088 141.219 155.807 137.119L159.341 116.985L177.314 107.414C180.981 105.462 182.439 100.953 180.62 97.2138L171.652 78.8531L180.6 60.4923C182.419 56.7535 180.962 52.2442 177.295 50.2919L159.303 40.7206L155.788 20.5867C155.069 16.4867 151.249 13.69 147.144 14.2758L126.968 17.1357L112.339 2.93136C110.855 1.4866 108.925 0.757812 107 0.757812ZM38.7381 127.834L0 166.71L29.1818 176.472L38.9091 205.758L83.5558 160.952L81.1619 158.664L69.2308 160.342C68.0636 160.508 66.9209 160.59 65.7731 160.59C53.7502 160.59 43.5078 151.955 41.4359 140.075L39.3651 128.177L38.7381 127.834ZM175.262 127.834L174.635 128.177L172.564 140.075C170.482 151.965 160.25 160.59 148.227 160.59C147.079 160.59 145.936 160.508 144.769 160.342L132.838 158.664L130.444 160.971L175.091 205.758L184.818 176.472L214 166.71L175.262 127.834Z"
      fill="#14B1E7"
    />
  </svg>
);
export default Confirm;
